export const INVOICE_SUB_AGENT_INTERNAL_LIST_REQUEST='INVOICE_SUB_AGENT_INTERNAL_LIST_REQUEST'
export const INVOICE_SUB_AGENT_INTERNAL_LIST_SUCCESS='INVOICE_SUB_AGENT_INTERNAL_LIST_SUCCESS'
export const INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL='INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL'

export const INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST='INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST'
export const INVOICE_SUB_AGENT_INTERNAL_CREATE_SUCCESS='INVOICE_SUB_AGENT_INTERNAL_CREATE_SUCCESS'
export const INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL='INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL'
export const INVOICE_SUB_AGENT_INTERNAL_CREATE_RESET='INVOICE_SUB_AGENT_INTERNAL_CREATE_RESET'

export const INVOICE_SUB_AGENT_INTERNAL_GET_REQUEST='INVOICE_SUB_AGENT_INTERNAL_GET_REQUEST'
export const INVOICE_SUB_AGENT_INTERNAL_GET_SUCCESS='INVOICE_SUB_AGENT_INTERNAL_GET_SUCCESS'
export const INVOICE_SUB_AGENT_INTERNAL_GET_FAIL='INVOICE_SUB_AGENT_INTERNAL_GET_FAIL'

export const INVOICE_SUB_AGENT_INTERNAL_UPDATE_REQUEST='INVOICE_SUB_AGENT_INTERNAL_UPDATE_REQUEST'
export const INVOICE_SUB_AGENT_INTERNAL_UPDATE_SUCCESS='INVOICE_SUB_AGENT_INTERNAL_UPDATE_SUCCESS'
export const INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL='INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL'
export const INVOICE_SUB_AGENT_INTERNAL_UPDATE_RESET='INVOICE_SUB_AGENT_INTERNAL_UPDATE_RESET'

export const INVOICE_SUB_AGENT_INTERNAL_DELETE_REQUEST='INVOICE_SUB_AGENT_INTERNAL_DELETE_REQUEST'
export const INVOICE_SUB_AGENT_INTERNAL_DELETE_SUCCESS='INVOICE_SUB_AGENT_INTERNAL_DELETE_SUCCESS'
export const INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL='INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL'
export const INVOICE_SUB_AGENT_INTERNAL_DELETE_RESET='INVOICE_SUB_AGENT_INTERNAL_DELETE_RESET'
